/* eslint-disable */
import './util/pardotForms';
import './util/modernizr';
import './util/objectFillPolyfill';

import jQuery from 'jquery';
import '../style.scss';

import scrollToTop2 from '../components/objects/scroll-to-top/scroll-to-top2';
import scrollToTop from '../components/objects/scroll-to-top/scroll-to-top';
import searchBar from '../components/objects/search/search-bar/search-bar';
import navMob from '../components/objects/nav/nav-mobile/nav-mobile';
import accordionTypeOne from '../components/objects/accordions/accordion-type-1/accordion';
import accordionTypeTwo from '../components/objects/accordions/accordion-type-2/accordion';
// import slider from '../components/blocks/slider/slider';
// import gallerySlider from '../components/blocks/photo-gallery/photo-gallery';
// import showPhotoCollageGallery from '../components/blocks/photo-collage/photo-collage';
// import gallery from '../components/blocks/gallery/gallery';
import socialShare from '../components/objects/social/social-share/social-share';
import {
    hamburger,
    hamburgerClose
} from '../components/objects/nav/hamburger/hamburger';

import scrollToAnchor from './custom/scroll/scroll-to-anchor';
import parallaxScroll from './custom/parallax/parallaxscroll';
import headRoom from './custom/headroom/headroom';
import {navToggler} from '../components/objects/slide-outs/slide-out-basic/slide-out-basic';
import mapBlock from '../components/objects/map/map';
import showTestimonials from '../components/blocks/testimonials/testimonials';
import showTeam from '../components/blocks/tabs-team/tabs-team';
import showTabs from '../components/blocks/tabs-form/tabs-form';
import showAlternativeGrid from '../components/blocks/grid-alternative/grid-alternative';
import showCertifiedPartners from '../components/blocks/certified-partners/certified-partners';
import showMediaSlider from '../components/blocks/media-slider/media-slider';

import './core/core';
/** Responsive Images Polyfill */
import 'picturefill';

// functions below are only run if the component exists (verified through a "data-module" in the html)
// in the ajax container or page. Barba.js instantiates the functions below on container reload as well.

// Place in alphabetical order
const app = {
    accordionTypeOne,
    accordionTypeTwo,
    hamburger,
    headRoom,
    searchBar,
    scrollToTop,
    scrollToTop2,
    socialShare,
    navToggler,
    mapBlock,
    showAlternativeGrid,
    showCertifiedPartners,
    showMediaSlider,
    showTeam,
    showTabs,
    showTestimonials,
};

let calledModulesNames = [];
app.instantiate = function (elem) {
    const $this = $(elem);
    const module = $this.attr('data-module');

    if (module === undefined) {
        throw 'Module not defined (use data-module="")';
    } else if (module in app) {
        if ($this.attr('data-initialized') === "true") return;
        new app[module](elem);
        $this.attr('data-initialized', true);
    } else {
        throw 'Module \'' + module + '\' not found';
    }
};

jQuery(document).ready(function () {
    scrollToAnchor($);
    navMob($);

    // Component functions that should only run if the component exists in the ajax container or page.
    $('[data-module]').each(function () {
        if ( $.inArray( $( this ).data( 'module' ), calledModulesNames ) == -1 ) {
            app.instantiate(this);

            calledModulesNames.push($(this).data('module'));
        }
    });

    $( '.c-hero .c-btn--anchor-type' ).on( 'click', function ( e ) {
        e.preventDefault();

        let heroButtonAnchor = $( this ).attr( 'href' );

        $( 'body, html' ).animate({
            scrollTop: $( heroButtonAnchor ).offset().top
        }, 1000);
    } );
});

jQuery(window).scroll(function () {
    parallaxScroll(jQuery);
});
